import React, { useState, useEffect } from 'react';
import { Row, Col } from 'reactstrap';
import Image from 'flaivy-react/components/Image';
import StyledButton from 'flaivy-react/components/StyledButton';
// @ts-ignore
import useWindowSize from 'flaivy-react/hooks/UseWindowSize';
import Link from 'next/link';
import type {
  Partner,
  PartnersDisplay as PartnersDisplayType,
} from 'domain-model/types/supplier-gateway';

function PartnersDisplayComponent({
  partnersDisplay,
}: {
  partnersDisplay: PartnersDisplayType;
}) {
  const [res, setRes] = useState({ y: 60, x: 107 });
  const windowSize = useWindowSize();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (windowSize.bootstrapSize === 'xs') {
        return setRes({ y: 35, x: 60 });
      }
      if (windowSize.bootstrapSize === 'sm') {
        return setRes({ y: 45, x: 80 });
      }
      return setRes({ y: 60, x: 107 });
    }
  }, [windowSize.bootstrapSize]);

  return (
    <div>
      <Row>
        <Col xs={12}>
          <h4>{partnersDisplay.title} </h4>
        </Col>
      </Row>
      <Row>
        {partnersDisplay?.partners?.map((partner: Partner) => (
          <Col
            xs={3}
            sm={2}
            key={partner.id}
            className="text-center py-5 border-top-0 border-bottom-0"
          >
            <Image
              src={partner?.partnerImage}
              resY={res.y}
              resX={res.x}
              alt="Customer"
            />
          </Col>
        ))}
      </Row>
      <Link href={partnersDisplay.buttonLink || '/'}>
        <StyledButton>{partnersDisplay.buttonText}</StyledButton>
      </Link>
    </div>
  );
}

export default PartnersDisplayComponent;
